const fieldMaterial = [
  { key: 'SKU', label: 'SKU' },
  { key: 'nombre', label: 'Nombre Material' },
  { key: 'categoria', label: 'Categoría' },
  { key: 'marca', label: 'Marca' },
  { key: 'cantidad', label: 'Cantidad Original' },
  { key: 'cantidadSolicitar', label: 'Cantidad a Solicitar' },
  { key: 'precio', label: 'Precio Unitario' },
  { key: 'total', label: 'Total Original' },
  { key: 'totalSolicitar', label: 'Total Solicitar' }
];

export default {
  fieldMaterial
};
